import { useTrackCheckoutPageStep } from './useTrackCheckoutPageStep'
import { useTrackCustomerCheckout } from './useTrackCustomerCheckout'
import { useTrackPaymentMethod } from './useTrackPaymentMethod'
import { useTrackShippingMethod } from './useTrackShippingMethod'

export const TrackCheckoutSteps = (): null => {
    useTrackCheckoutPageStep()
    useTrackCustomerCheckout()
    useTrackShippingMethod()
    useTrackPaymentMethod()
    return null
}
